import AINode from './agent';

const OpenAINode = ({ data }) => {
  return (
    <AINode
      agentId="leadership-gym"
      title="Leadership gym"
      description="Define the agent instructions, then enter a task to complete using tools"
      inputs={[
        {
          id: 'systemMessage',
          label: 'System Message',
          style: { top: 60 },
        },
        {
          id: 'input',
          label: 'Input',
          isReadOnly: true,
        },
        {
          id: 'tools',
          label: 'Tools',
        },
      ]}
      outputs={[
        {
          id: 'text',
        },
        {
          id: 'languageModel',
          style: { top: 60 },
        },
      ]}
      modelOptions={[{ key: 'gpt-4o-mini', value: 'gpt-4o-mini' }]}
      style={{
        handleColor: 'blue',
        iconColor: 'blue',
      }}
    />
  );
};

export default OpenAINode;
